module.exports = __webpack_public_path__ + "images/icon/triangle_down_navy-f4321c6a.svg";